
import { useState, useEffect } from 'react';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isScrolled ? 'bg-[#0B0D10]/90 backdrop-blur-xl shadow-lg shadow-black/20' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center">
            <img
              src="https://static.readdy.ai/image/0fc33fa68f46f743570ad8ba1c3172ea/b159d9a361187084121e81321b9594ff.png"
              alt="AI Business Partners"
              className="h-24 w-auto"
            />
          </div>

          <div className="hidden md:flex items-center gap-8">
            <a
              href="#approach"
              className="text-xs text-[#F5F7FA]/70 hover:text-[#F5F7FA] transition-colors cursor-pointer whitespace-nowrap tracking-wide"
            >
              Our Approach
            </a>
            <a
              href="#who-we-work-with"
              className="text-xs text-[#F5F7FA]/70 hover:text-[#F5F7FA] transition-colors cursor-pointer whitespace-nowrap tracking-wide"
            >
              Industries
            </a>
            <a
              href="#outcomes"
              className="text-xs text-[#F5F7FA]/70 hover:text-[#F5F7FA] transition-colors cursor-pointer whitespace-nowrap tracking-wide"
            >
              Outcomes
            </a>
            <a
              href="#consultation"
              className="px-5 py-2 bg-[#F5F7FA] text-[#0B0D10] text-xs font-semibold rounded-full hover:bg-white transition-all cursor-pointer whitespace-nowrap hover:scale-105 duration-300"
            >
              Request Audit
            </a>
          </div>

          <button
            onClick={() => setIsMobileOpen(!isMobileOpen)}
            className="md:hidden w-8 h-8 flex items-center justify-center cursor-pointer"
            aria-label="Toggle menu"
          >
            <i className={`${isMobileOpen ? 'ri-close-line' : 'ri-menu-line'} text-xl text-[#F5F7FA]`}></i>
          </button>
        </div>
      </div>

      {isMobileOpen && (
        <div className="md:hidden bg-[#0B0D10]/95 backdrop-blur-xl border-t border-[#F5F7FA]/5">
          <div className="px-6 py-6 space-y-4">
            <a
              href="#approach"
              onClick={() => setIsMobileOpen(false)}
              className="block text-sm text-[#F5F7FA]/70 hover:text-[#F5F7FA] transition-colors cursor-pointer"
            >
              Our Approach
            </a>
            <a
              href="#who-we-work-with"
              onClick={() => setIsMobileOpen(false)}
              className="block text-sm text-[#F5F7FA]/70 hover:text-[#F5F7FA] transition-colors cursor-pointer"
            >
              Industries
            </a>
            <a
              href="#outcomes"
              onClick={() => setIsMobileOpen(false)}
              className="block text-sm text-[#F5F7FA]/70 hover:text-[#F5F7FA] transition-colors cursor-pointer"
            >
              Outcomes
            </a>
            <a
              href="#consultation"
              onClick={() => setIsMobileOpen(false)}
              className="block px-5 py-2.5 bg-[#F5F7FA] text-[#0B0D10] text-sm font-semibold rounded-full text-center cursor-pointer whitespace-nowrap"
            >
              Request Audit
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}
